<template>
  <div class="container">
    <header class="jumbotron">
      <h3>Resultados de su búsqueda:</h3>
      <div v-if="processing">
        Buscando...
      </div>
      <div v-else>
        <p>{{foundQty}} resultados encontrados por el término "{{query}}"</p>

        <ul>
          <li v-for="(issue, index) in issuesFound" :key="index">
            <!-- name: 'issue-details', -->
            <router-link :to="{
              name: 'tickets',
              params: { issue: issue }
            }"
            >
              <div>
                #{{ getTicketId(issue) }} - {{issue.customer.firstName}} ({{issue.customer.phone}})
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </header>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
import { getTicketId } from '@/utils/page-utils';

export default {
    name: 'Search',
    props: {
        query: String
    },
    data() {
        return {
            issuesFound: [],
            processing: true,
            foundQty: 0
        };
    },
    created() {
        IssueService.searchIssues(this.query).then(
            response => {
                this.issuesFound = response.data;
                this.foundQty = this.issuesFound.length;
                this.processing = false;
            },
            error => {
                console.log(error.response && error.response.data ||
          error.message || error.toString());
            }
        );
    },
    methods: {
        getTicketId
    }
};
</script>
<style>
[v-cloak] > * { display:none }
[v-cloak]::before { content: "…" }
</style>
